import React from 'react'
import { host } from '@Api'
const image = 'https://img.8891.com.tw/next'

const AppPopover: React.FC = () => (
  <div className="tc-top-nav-right-popover app-download">
    <h3>下載8891APP</h3>
    <img className="app-download-banner" src={`${image}/header/img-1.png`} />
    <h3>數字APP</h3>
    <ul className="app-download-list">
      <li className="app-download-list-item">
        <a href="https://www.8591.com.tw/news-app.html?aid=849" target="_blank" title="8591寶物交易">
          <img src={`https://photo.8891.com.tw/2025/04/24/1745458793080102.png`} alt="8591寶物交易" />
          <p>8591寶物交易</p>
        </a>
      </li>
      <li className="app-download-list-item">
        <a href="https://www.591.com.tw#anchor_app" target="_blank" title="591房屋交易">
          <img src={`${image}/header/icon-591.png`} alt="591房屋交易" />
          <p>591房屋交易</p>
        </a>
      </li>
      <li className="app-download-list-item">
        <a href={`${host.www}#eight_carousel`} target="_blank" title="8891新車">
          <img src={`${image}/header/icon-8891-newCar.png`} alt="8891新車" />
          <p>8891汽車</p>
        </a>
      </li>
      <li className="app-download-list-item">
        <a href="https://www.8891.com.tw/index-appDown.html" target="_blank" title="8891汽車交易">
          <img src={`${image}/header/icon-8891.png`} alt="8891汽車交易" />
          <p>8891中古車</p>
        </a>
      </li>
      <li className="app-download-list-item">
        <a href="https://uc.100.com.tw/apps-download.html" target="_blank" title="100室內設計">
          <img src={`${image}/header/icon-100.png`} alt="100室內設計" />
          <p>100室內設計</p>
        </a>
      </li>
      <li className="app-download-list-item">
        <a href="https://www.518.com.tw/" target="_blank" title="518 熊班">
          <img src={`${image}/header/ic_bearworks_job.svg`} alt="518 熊班" width="60" />
          <p>518 熊班</p>
        </a>
      </li>
      <li className="app-download-list-item">
        <a href="https://www.tasker.com.tw" target="_blank" title="Tasker 出任務">
          <img src={`${image}/header/icon-518-bag4.png`} alt="Tasker 出任務" />
          <p>Tasker出任務</p>
        </a>
      </li>
      <li className="app-download-list-item">
        <a href="https://518.com.tw/15043" target="_blank" title="小雞上工">
          <img src={`${image}/header/icon-xiaoji.png`} alt="小雞上工" />
          <p>小雞上工</p>
        </a>
      </li>
      <li className='app-download-list-item'>
        <a href='https://www.addcn.com/app/job-listings' target='_blank' title='數字徵才' rel='noreferrer'>
          <img src={`https://photo.8891.com.tw/2023/12/29/1703821333754602.png`} width={60} height={60} style={{ objectFit: 'cover', border: '1px solid #e4e4e4', borderRadius: '14px' }} alt='數字徵才' />
          <p>數字徵才</p>
        </a>
      </li>
    </ul>
  </div>
)

export default AppPopover
